<template>
  <div :class="[bem(''), { center }]">
    <div :class="bem('first')" tabindex="0" @click="listClick" v-if="type === 1">
      <div :class="bem('name')">{{ name }}</div>
      <div :class="bem('middle')">
        <div :class="bem('middle-top')" v-if="title">
          <div :class="bem('title')">{{ title }}</div>
          <div :class="bem('right-text')">{{ rightText }}</div>
        </div>
        <div :class="bem('content')">
          <slot />
        </div>
      </div>
      <div>
        <v-icon :class="bem('right-icon')" :name="rightIcon" />
      </div>
    </div>
    <div :class="bem('second')" v-if="type === 2">
      <div :class="bem('header')" tabindex="0" @click="listClick">
        <div :class="bem('header-left')">
          <div :class="bem('name')">{{ name }}</div>
          <div :class="bem('sub-name')">{{ subName }}</div>
        </div>
        <div :class="bem('right')">
          <div :class="bem('right-text')">{{ rightText }}</div>
          <v-icon :class="bem('right-icon')" :name="rightIcon" />
        </div>
      </div>
      <div :class="bem('content')">
        <slot />
      </div>
    </div>
    <div :class="bem('second')" v-if="type === 3">
      <div :class="bem('header')" tabindex="0" @click="listClick">
        <div :class="bem('header-left')">
          <div :class="bem('name')">{{ name }}</div>
          <div :class="bem('sub-name')">{{ subName }}</div>
        </div>
        <div :class="bem('right')">
          <div :class="bem('right-text')" v-html="rightText"></div>
          <v-icon :class="bem('right-icon')" :name="rightIcon" />
        </div>
      </div>
      <div :class="bem('content')">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import create from '../create'

export default create({
  name: 'list-view',
  props: {
    // name和右箭头对齐方式
    type: {
      type: Number,
      default: 1
    },
    center: false,
    name: String,
    subName: String,
    title: String,
    rightText: {
      type: String,
      default: ''
    },
    rightIcon: {
      type: String,
      default: 'arrow-right'
    }
  },
  methods: {
    listClick(e) {
      this.$emit('click', e)
    }
  }
})
</script>

<style lang="scss" src="./index.scss"></style>
